import { ReduxAction } from './../../constants';
const initialState = {};
// Location Tab
const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReduxAction.countryStateList: {
      return {
        ...state,
        countryStateList: action.payload?.countryStateList,
      };
    }
    case ReduxAction.locationTransferSaved: {
      return {
        ...state,
        locationTransferSavedAt: action.payload,
      };
    }
    default:
      return state;
  }
};
export default locationReducer;
